import {
  SimpleShowLayout,
  Show,
  TextField,
  ReferenceArrayField,
  SingleFieldList,
  FunctionField,
  Labeled,
} from "react-admin";
import { Grid, useMediaQuery } from "@mui/material";
import { administrationRequests } from "api/administrationApi";
import { settings } from "app";
import BackButtonToolbar from "features/BackButtonToolbar";
import { SectionTitle } from "features/SectionTitle";

const ShowBuildings = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <Show
      title="Детайли за сграда"
      actions={<BackButtonToolbar />}
    >
      <SimpleShowLayout>
        <SectionTitle
          title="Информация"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />

        <Grid
          container
          spacing={3}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Име на български език">
              <TextField source="nameBg" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Име на английски език">
              <TextField source="nameEn" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Адрес">
              <TextField source="address" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Географска ширина">
              <TextField source="latitude" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Географска дължина">
              <TextField source="longitude" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Външна сграда">
              <FunctionField
                source="isExternal"
                render={record => record.isExternal ? 'Да' : 'Не'}
              />
            </Labeled>
          </Grid>
        </Grid>
      </SimpleShowLayout>

      <SimpleShowLayout>
        <SectionTitle
          title="Данни за сградата"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />
        <Grid
          container
          spacing={2}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
          >
            <Labeled label="Зали">
              <ReferenceArrayField
                source="roomIds"
                reference={administrationRequests.getRoomsSelect()}
              >
                <SingleFieldList>
                  <FunctionField
                    label="Зали"
                    render={rec => `${rec.roomName}`}
                  />
                </SingleFieldList>
              </ReferenceArrayField>
            </Labeled>
          </Grid>
        </Grid>
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowBuildings;
